import { schema } from "normalizr";
export const email = new schema.Entity("email");
export const emailSchema = new schema.Entity("emails", {
  emails: [email]
}, {
  idAttribute: "emailId"
});
export const list = new schema.Entity("list");
export const listSchema = new schema.Entity("lists", {
  lists: [list]
}, {
  idAttribute: "listId"
});
export const campaign = new schema.Entity("campaign");
export const campaignSchema = new schema.Entity("campaigns", {
  campaigns: [campaign]
}, {
  idAttribute: "campaignId"
});